import React, { useState } from "react";

import {
  Button,
  TextField,
  Box,
  Stack,
  Alert,
  Paper,
  Typography,
} from "@mui/material";
import { PlaylistAdd as WaitlistIcon } from "@mui/icons-material";
import DB from "_DatabaseFunctions/directConnect";

interface GameInfo {
  id: string;
  [key: string]: any;
}

interface AddToWaitlistFieldProps {
  gameInfo: GameInfo;
  setModalDets?: (dets: any) => void;
}

const AddToWaitlistField: React.FC<AddToWaitlistFieldProps> = ({
  gameInfo,
}) => {
  const gameId = gameInfo.id;

  const [playerName, setPlayerName] = useState("");
  const [msg, setMsg] = useState("");
  const [msgType, setMsgType] = useState<"success" | "error">("error");

  const addPlayerManually = async (event: React.FormEvent) => {
    event.preventDefault();
    const res = await DB.addPlayerToWaitManually(gameId, playerName);
    setMsg(res.msg);
    
    // Determine message type based on response content
    if (res.msg.toLowerCase().includes("successfully") || res.msg.toLowerCase().includes("added")) {
      setMsgType("success");
    } else {
      setMsgType("error");
    }
    
    setPlayerName("");
  };

  return (
    <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom sx={{ mb: 2, fontWeight: 500, color: "text.primary", fontSize: "1.1rem" }}>
        Add Player to Waitlist
      </Typography>
      
      <Box
        component="form"
        onSubmit={async (event) => {
          await addPlayerManually(event);
        }}
        sx={{ width: "100%" }}
      >
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
          <TextField
            fullWidth
            variant="outlined"
            label="Player Name"
            placeholder="Enter player's name"
            value={playerName}
            onChange={(event) => setPlayerName(event.target.value)}
            required
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
          />
          <Button
            type="submit"
            variant="contained"
            color="warning"
            startIcon={<WaitlistIcon />}
            onClick={async (event) => {
              await addPlayerManually(event);
            }}
            size="large"
            sx={{
              minWidth: 200,
              fontWeight: 500,
              borderRadius: 2,
              whiteSpace: "nowrap",
            }}
          >
            Add to Waitlist
          </Button>
        </Stack>
      </Box>
      
      {msg && (
        <Alert severity={msgType} sx={{ mt: 2 }}>
          {msg}
        </Alert>
      )}
    </Paper>
  );
};

export default AddToWaitlistField;
